// Reusable form field wrapper with label, input, and error message
import React from 'react';
import { View, Text, TextInput, StyleSheet, TextInputProps } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin';

interface FormFieldProps extends TextInputProps {
  label: string;
  error?: string;
  required?: boolean;
  helpText?: string;
}

export const FormField: React.FC<FormFieldProps> = ({
  label,
  error,
  required,
  helpText,
  style,
  ...textInputProps
}) => {
  return (
    <View style={styles.field}>
      <Text style={styles.label}>
        {label} {required && '*'}
      </Text>
      <TextInput
        style={[styles.input, error && styles.inputError, style]}
        placeholderTextColor={ADMIN_COLORS.TEXT_TERTIARY}
        {...textInputProps}
      />
      {error ? <Text style={styles.errorText}>{error}</Text> : null}
      {helpText && !error ? <Text style={styles.helpText}>{helpText}</Text> : null}
    </View>
  );
};

const styles = StyleSheet.create({
  field: {
    marginBottom: 20,
  },
  label: {
    fontSize: 14,
    fontWeight: '500',
    color: ADMIN_COLORS.TEXT.SECONDARY,
    marginBottom: 8,
  },
  input: {
    borderWidth: 1,
    borderColor: ADMIN_COLORS.BORDER,
    borderRadius: 8,
    padding: 12,
    fontSize: 14,
    color: ADMIN_COLORS.TEXT.PRIMARY,
    backgroundColor: ADMIN_COLORS.BACKGROUND.PRIMARY,
  },
  inputError: {
    borderColor: '#F87171',
  },
  errorText: {
    color: '#F87171',
    fontSize: 12,
    marginTop: 4,
  },
  helpText: {
    color: ADMIN_COLORS.TEXT.SECONDARY,
    fontSize: 12,
    marginTop: 4,
  },
});

